import Contact from "@/components/Contact";
import { PageBackdrop } from "@/components/PageBackdrop";
import { FallingPetals } from "@/components/FallingPetals";
import { usePageMeta } from "@/hooks/usePageMeta";

const ContactPage = () => {
  usePageMeta("Vagus Digital | Contact");
  return (
    <div className="relative min-h-screen overflow-hidden bg-paper pt-16 lg:pt-20 [&>section]:!border-0 [&>section]:!bg-transparent">
      <PageBackdrop src="/art/contact.webp" />
      <FallingPetals />
      <Contact />
    </div>
  );
};

export default ContactPage;
